module.exports = __webpack_public_path__ + "img/cases-brand-chinamobile-lazyload-62.521c4b9b.jpg";